module.exports = __webpack_public_path__ + "static/media/Clothify.34186d6c.png";